import React from 'react';
import PropTypes from 'prop-types';
import { sendToGA } from '@react-shared/helpers/send-to-ga';
import styles from './link.module.scss';

const Link = ({ item, active }) => (
  <a
    href={item.url}
    className={`${active ? styles.currentPage : ''}`}
    onClick={() => sendToGA({
      event: 'Menu',
      action: 'MenuLinkSelect',
      type: 'link'
    })}
  >
    {item.linkText}
  </a>
);

Link.propTypes = {
  item: PropTypes.any.isRequired,
  active: PropTypes.bool.isRequired
};

export default Link;
